import { FormValidationRule } from "../../forms/types";
import isCountryCodeSet from "./isCountryCodeSet";
import isValidNumber from "./isValidNumber";
import isValidNumberForRegion from "./isValidNumberForRegion";
import isFixedLine from "./isFixedLine";
import isMobile from "./isMobile";

const phoneRules: FormValidationRule = (c, v) => {
    let valid = true;
    let message = "";

    if (c.type === "phone" && v) {
        [valid, message] = isValidNumber(c, v);

        message = c.errorMessage || message;
    }

    if (c.type === "boi_phone" && v) {
        [valid, message] = isCountryCodeSet(c, v);
        [valid, message] = valid ? isValidNumber(c, v) : [valid, message];
        [valid, message] = valid
            ? isValidNumberForRegion(c, v)
            : [valid, message];
        [valid, message] = valid ? isFixedLine(c, v) : [valid, message];
        [valid, message] = valid ? isMobile(c, v) : [valid, message];

        message = c.errorMessage || message;
    }
    return [valid, message];
};

export default phoneRules;
